import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import HazardousIcon from "@MasterBluePrint/Icons/Hazardous";
import ShippingIcon from "@MasterBluePrint/Icons/Shipping";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    showShippingRestrictionIcon: boolean;
    showHazardousGoodIcon: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    settingsCollection: getSettingsCollection(state),
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProductContext;

export interface ProductListHazmatIconStyles {
    container?: GridContainerProps;
    hazmatGridItem?: GridItemProps;
}

export const productHazmatStyles: ProductListHazmatIconStyles = {
    container: {
        gap: 10,
        css: css`
            width: 100%;
        `,
    },
    hazmatGridItem: {
        width: 12,
        css: css`
            padding: .625rem .31250625rem;
        `,

    },
};

const styles = productHazmatStyles;

const ProductListHazmatIcon: FC<Props> = ({
    productContext,
    showShippingRestrictionIcon,
    showHazardousGoodIcon,
}) => {
    const { product } = productContext;

    let shippingIconText = "";
    let isShowShippingIconText = true;

    if (!product) {
        return null;
    }

    if (product.detail?.shippingClassification?.toLowerCase() === "mp"
        || product.detail?.shippingClassification?.toLowerCase() === "md") {
        shippingIconText = translate("Next Day Air Only");
    }

    if (product.detail?.shippingClassification?.toLowerCase() === "mg"
        || product.detail?.shippingClassification?.toLowerCase() === "mc"
        || product.detail?.shippingClassification?.toLowerCase() === "mb") {
        shippingIconText = translate("Cannot Ship Air");
    }

    if (product.detail?.shippingClassification?.toLowerCase() === ""
        || product.detail?.shippingClassification?.toLowerCase() === "ml"
        || product.detail?.shippingClassification?.toLowerCase() === "ms") {
        isShowShippingIconText = false;
    }


    const hazardousIconText = product.detail?.isHazardousGood ? translate("Hazardous") : "";

    return (
        <GridContainer {...styles.container}>
            {showShippingRestrictionIcon && isShowShippingIconText && (
                <GridItem {...styles.hazmatGridItem}>
                    <Icon title={shippingIconText} src={ShippingIcon}
                        css={css`
                                        margin-right: 0;
                                        width: 2rem!important;
                                        > svg {
                                            width: 2rem;
                                        }
                                    `}
                    />
                    {shippingIconText}
                </GridItem>
            )}
            {showHazardousGoodIcon && product.detail?.isHazardousGood && (
                <GridItem {...styles.hazmatGridItem}>
                    <Icon title={hazardousIconText} src={HazardousIcon}
                        css={css`
                                        margin-right: 0;
                                        width: 2rem!important;

                                        > svg {
                                            width: 2rem;
                                        }
                                    `}
                    />
                    {hazardousIconText}
                </GridItem>
            )}
        </GridContainer>
    );
};

export default connect(mapStateToProps)(withProductContext(ProductListHazmatIcon));